import React, { FC } from 'react';
import { Button } from '@clearcover/atlas';
import { toTitleCase } from 'Shared/utils';
import { ChallengeType } from 'QuoteApp/services/endpoints/PostChallengeAccident';
interface ChallengeButtonProps {
  onClick(): void;
  variant: ChallengeType;
  disabled?: boolean;
  className?: string;
  dataTestId?: string;
}

export const ChallengeButton: FC<ChallengeButtonProps> = ({
  onClick,
  variant,
  disabled,
  className,
  dataTestId,
}) => {
  return (
    <Button
      variant={variant === 'remove' ? 'danger-secondary' : 'secondary'}
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className={className}
      data-testid={dataTestId}
    >
      {toTitleCase(variant)}
    </Button>
  );
};
